import { PaymentInputCardInfo } from '@app/payment-input/container';

/**
 * カード選択情報Data
 * @param   creditCardInfo カード情報
 */
export interface PaymentInputCardSelectingData {
  creditCardInfo: PaymentInputCardInfo;
  selectedCard: RegisteredCardTypeEnum;
}
export function initPaymentInputCardSelectingData(): PaymentInputCardSelectingData {
  return {
    creditCardInfo: {
      uatpCard: false, // UATP
      cardNumber: '', // カード番号
      cardExpiryDate: '', // 有効期限
      cvv: '', // CVV
      ownerName: '', // 名義
      reservation: false, // 登録
    },
    selectedCard: RegisteredCardTypeEnum.NewCard,
  };
}

/**
 * カード選択情報Parts
 */
export interface PaymentInputCardSelectingParts {
  selectedPaymentMethod: string;
}

export function initPaymentInputCardSelectingParts(): PaymentInputCardSelectingParts {
  return {
    selectedPaymentMethod: '',
  };
}

export type RegisteredCardTypeEnum = 'newCard' | 'paymentCard1' | 'paymentCard2';
export const RegisteredCardTypeEnum = {
  NewCard: 'newCard' as RegisteredCardTypeEnum,
  PaymentCard1: 'paymentCard1' as RegisteredCardTypeEnum,
  PaymentCard2: 'paymentCard2' as RegisteredCardTypeEnum,
};
